
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rezepte/[...id]",
      function () {
        return require("private-next-pages/rezepte/[...id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/rezepte/[...id]"])
      });
    }
  